function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { FocusZone, FocusZoneDirection, FocusZoneTabbableElements } from 'office-ui-fabric-react';
import isEqual from 'react-fast-compare';
import { Stack } from '../../Stack';
import { DeleteCell } from '../../Table/cells/Delete';
import { SelectCheckCell } from '../../Table/cells/SelectCheckCell';
import { SimpleTable } from '../../Table/SimpleTable';
import { EditorRow } from './EditorRow';
import { InlineEditField } from './InlineEditField';
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
const typedMemo = React.memo;
export function typedInlineEditTable(props) {
  var _props$selectRow;
  const {
    isDeleteDisabled,
    onRowDelete
  } = props;
  const getColumns = React.useCallback(() => {
    let columns = [];
    if (!props.disableRowCheckBox) {
      columns.push({
        id: 'select',
        accessor: 'id',
        width: '20',
        minWidth: 20,
        disableSortBy: true,
        disableFilters: true,
        Cell: cellProps => {
          return /*#__PURE__*/_jsx(InlineEditField, _objectSpread(_objectSpread({}, cellProps), {}, {
            viewComponent: /*#__PURE__*/_jsx(_Fragment, {}),
            editComponent: /*#__PURE__*/_jsx(SelectCheckCell, _objectSpread({}, cellProps))
          }));
        }
      });
    }
    columns = columns.concat(...props.columns);
    if (!props.disabled && !props.disableDelete) {
      columns.push({
        id: 'delete',
        accessor: 'id',
        width: 20,
        minWidth: 20,
        disableSortBy: true,
        disableFilters: true,
        Cell: cellProps => {
          var _cellProps$row$origin, _isDeleteDisabled;
          const rowItem = (_cellProps$row$origin = cellProps.row.original) !== null && _cellProps$row$origin !== void 0 ? _cellProps$row$origin : cellProps.row.values;
          return /*#__PURE__*/_jsx(DeleteCell, _objectSpread(_objectSpread({}, cellProps), {}, {
            onConfirm: onRowDelete,
            disabled: (_isDeleteDisabled = isDeleteDisabled === null || isDeleteDisabled === void 0 ? void 0 : isDeleteDisabled(rowItem)) !== null && _isDeleteDisabled !== void 0 ? _isDeleteDisabled : false
          }));
        }
      });
    }
    return columns;
  }, [props.columns, props.disabled, isDeleteDisabled]);
  return /*#__PURE__*/_jsx(Stack, {
    "data-id": props.id,
    children: /*#__PURE__*/_jsx(FocusZone, {
      direction: FocusZoneDirection.vertical,
      isCircularNavigation: true,
      handleTabKey: FocusZoneTabbableElements.all,
      shouldFocusInnerElementWhenReceivedFocus: true,
      children: /*#__PURE__*/_jsx(SimpleTable, _objectSpread(_objectSpread({}, props), {}, {
        columns: getColumns(),
        selectRowId: (_props$selectRow = props.selectRow) === null || _props$selectRow === void 0 ? void 0 : _props$selectRow.toString(),
        TableRowComponent: rowProps => {
          return /*#__PURE__*/_jsx(EditorRow, _objectSpread(_objectSpread({}, rowProps), {}, {
            onValidation: props.onValidation,
            onValidationError: props.onValidationError,
            disabled: props.disabled,
            inputList: props.inputList,
            onUpdate: props.onRowUpdate,
            style: props.rowStyle,
            selected: props.selectedRow === rowProps.row.id,
            select: () => props.selectRow && props.selectRow(rowProps.row.id),
            disableInvalidIndicator: props.disableInvalidRowIndicator,
            disableAutoFocus: props.disableRowInputAutoFocus
          }), "editorrow-".concat(rowProps.row.id));
        },
        data: props.data
      }))
    })
  });
}
export const InlineEditTable = typedMemo(typedInlineEditTable, (_prev, _next) => {
  const {
    data: prevData,
    sortBy: prevSortBy,
    selectedRow: prevSelectedRow,
    shouldReRenderOnSingleRowChange = false,
    shouldReRenderOnDisabledChange = false
  } = _prev;
  const {
    data: nextData,
    sortBy: nextSortBy,
    selectedRow: nextSelectedRow
  } = _next;
  if (shouldReRenderOnDisabledChange && _prev.disabled !== _next.disabled) return false;
  if (!isEqual(prevSortBy, nextSortBy)) {
    return false;
  }
  if (!isEqual(prevSelectedRow, nextSelectedRow)) {
    return false;
  }
  if (!isEqual(prevData, nextData)) {
    if (nextData.length !== prevData.length) {
      return false;
    }
    if (!nextSelectedRow) {
      return false;
    }
    const a = [...prevData];
    const b = [...nextData];
    a.splice(parseInt(nextSelectedRow), 1);
    b.splice(parseInt(nextSelectedRow), 1);
    const onlyCurrentSelectedRowChanged = isEqual(a, b);
    //if only current editing row changed don't re-render (inputgroup handles local state)
    if (!onlyCurrentSelectedRowChanged || shouldReRenderOnSingleRowChange) {
      return false;
    }
  }
  return true;
});